import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PaymentStatus } from '../enums/payment-status';

@Injectable({
  providedIn: 'root',
})
export class PaymentStatusProviderService {
  private readonly entries = new Map<PaymentStatus, string>([
    [PaymentStatus.New, 'Nowa'],
    [PaymentStatus.Pending, 'W trakcie'],
    [PaymentStatus.Cancelled, 'Anulowana'],
    [PaymentStatus.Completed, 'Zakończona'],
    [PaymentStatus.PartiallyRefunded, 'Częściowo zwrócona'],
    [PaymentStatus.Refunded, 'Zwrócona'],
  ]);

  public labelFor(status: PaymentStatus): Observable<string> {
    return of(this.entries.get(status) || 'Nieznany');
  }
}
